import { supabase } from '@/integrations/supabase/client';
import type { PlaceData } from '@/types/placeDetail';

/**
 * Fetches a single place row by exact `Name` match (decoded URL segment).
 * Uses full row select so we never miss a column the UI or scrapers rely on.
 */
export async function fetchPlaceByName(decodedName: string): Promise<PlaceData> {
  const { data, error } = await supabase
    .from('podcasts')
    .select('*')
    .eq('Name', decodedName)
    .maybeSingle();

  if (error) throw error;
  if (!data) {
    const err = new Error('PLACE_NOT_FOUND');
    throw err;
  }
  return data as PlaceData;
}